import React from 'react';

export function InputProfile({error, type, placeholder = '', name, title, value, disabled, onChange, rows = 2, className = ''}) {

  return <div className={"profile__group" + (className ? ' ' + className : '')}>
    <p className="profile__help help">{title}</p>
    {type === 'textarea' && <textarea name={name}
                                      className={"profile__input input" + (error ? " input--error" : "")}
                                      placeholder={placeholder}
                                      rows={rows}
                                      value={value}
                                      disabled={disabled}
                                      onChange={onChange}></textarea>}
    {type !== 'textarea' && <input type={type}
                                   name={name}
                                   className={"profile__input input" + (error ? " input--error" : "")}
                                   placeholder={placeholder}
                                   value={value}
                                   disabled={disabled}
                                   onChange={onChange}/>}
  </div>;
}
